type EditorialHeadingProps = {
  kicker: string;
  eyebrow?: string;
  title: React.ReactNode;
  lead?: string;
  id?: string;
};

export function EditorialHeading({ kicker, eyebrow, title, lead, id }: EditorialHeadingProps) {
  return (
    <div className="animate-slide-in-up">
      <div className="flex flex-wrap items-center justify-between gap-4 border-b border-premium-gold/25 pb-4">
        <span className="text-[11px] uppercase tracking-[0.32em] text-premium-gold font-semibold">{kicker}</span>
        {eyebrow && (
          <span className="text-[11px] uppercase tracking-[0.28em] text-white/60">{eyebrow}</span>
        )}
      </div>

      <div className="grid grid-cols-1 lg:grid-cols-12 gap-8 lg:gap-14 pt-8 md:pt-10">
        <h2
          id={id}
          className="lg:col-span-7 font-black leading-[0.98] tracking-tight text-foreground text-[2.1rem] sm:text-5xl xl:text-[3.4rem]"
        >
          {title}
        </h2>
        {lead && (
          <div className="lg:col-span-5 lg:pt-2">
            <p className="border-l-2 border-primary/70 pl-5 text-base md:text-lg text-muted-foreground leading-relaxed">
              {lead}
            </p>
          </div>
        )}
      </div>
    </div>
  );
}
